<!--
 * @Author: zl
 * @Date: 2021-09-16 10:41:39
 * @LastEditTime: 2021-11-24 16:49:22
 * @LastEditors: zl
 * @Description: 
-->
<template>
	<div class="add-layout-contract primary-layout">
		<div class="primary-content padding-style"
			 :class="{ noStar: routeType == 'view' }">
			<el-collapse v-model="activeNames"
						 v-if="activeName == '1'">
				<el-collapse-item title="#1 合同基本信息"
								  name="1">
					<el-form ref="contractForm"
							 :model="contractForm"
							 label-width="170px"
							 size="small">
						<el-row>
							<el-col :span="23">
								<el-form-item label="所属项目：">
									<TextTooltip :content="projectName"
												 :refName="'projectName'"></TextTooltip>
								</el-form-item>
							</el-col>
							<el-col :span="23">
								<el-form-item label="关联任务：">
									<TextTooltip :content="contractForm.taskNames "
												 :refName="'contractFormtaskNames '"></TextTooltip>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="合同名称：">
									<TextTooltip :content="contractForm.sname"
												 :refName="'contractFormSname'"></TextTooltip>
								</el-form-item>
							</el-col>
							<el-col :span="11"
									:offset="1">
								<el-form-item label="合同编号：">
									<TextTooltip :content="contractForm.contractNo"
												 :refName="'contractFormContractNo'"></TextTooltip>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="合同类型：">
									<span>{{ contractForm.contractName }}</span>
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="相关文件：">
									<span class="blue-text"  @click="jumpHref">{{ dealFile(templateId) }}</span>
								</el-form-item>
							</el-col>
                        </el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="计划开始日期：">
									<span>{{ contractForm.startDate ? contractForm.startDate.substr(0, 11) : '无' }}</span>
								</el-form-item>
							</el-col>
							<el-col :span="11"
									:offset="1">
								<el-form-item label="计划结束日期：">
									<span>{{ contractForm.endDate ? contractForm.endDate.substr(0, 11) : '无' }}</span>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="合同结算方式：">
									<TextTooltip :content="contractForm.typeName"
												 :refName="'contractFormtypeName'"></TextTooltip>
								</el-form-item>
							</el-col>
                            <el-col :span="11"
									:offset="1">
								<el-form-item label="合同状态：">
									<span>{{ contractForm.status ? contractForm.statusName : '无' }}</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="11">
								<el-form-item label="合同金额：">
									<span>
										{{ contractForm.isEstimate ? '估值   ' : '' }}
										{{ contractForm.amount + ' 元' }}
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="11" :offset="1">
								<el-form-item label="公式：">
									合同金额 = 计费基数金额 × 费率 × 优惠折扣
								</el-form-item>
							</el-col>
                        </el-row>
                        <template v-if="contractForm.type == '1012002'">
                            <el-row v-for="(item, index) in copyObj.busProjectContractBaseBilItems" :key="'copyObj' + index">
                                <el-col :span="11">
									<el-form-item label="计费基数：">
										<span>{{ item.chargeBaseName }}</span>
									</el-form-item>
								</el-col>
                                <el-col :span="6">
									<el-form-item label="费率："
												  label-width="80px">
										<span>{{ item.rate + ' %' }}</span>
									</el-form-item>
								</el-col>
                                <el-col :span="6">
									<el-form-item label="优惠折扣："
												  label-width="120px">
										<span>{{ item.discount + ' %' }}</span>
									</el-form-item>
								</el-col>
                            </el-row>
                        </template>
                        <el-row>
							<el-col :span="23">
								<el-form-item label="备注：">
									<span>{{ contractForm.remark || '无' }}</span>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="#2 签约双方信息"
								  name="2">
					<el-form ref="bothForm"
							 :model="copyObj"
							 label-width="170px"
							 size="small">
						<template v-for="(item, index) in copyObj.busProjectContractParties">
							<el-row :key="'busProjectContractParties' + index">
								<div v-if="item.type == 0">
									<el-col :span="11">
										<el-form-item label="签约单位（甲方）：">
											<TextTooltip :content="item.sname"
														 :refName="'busProjectContractParties.' + index + '.sname'">
											</TextTooltip>
										</el-form-item>
									</el-col>
									<el-col :span="11"
											:offset="1">
										<el-form-item label="甲方签约人：">
											<TextTooltip :content="item.handlerName"
														 :refName="'busProjectContractParties.' + index + '.handlerName'">
											</TextTooltip>
										</el-form-item>
									</el-col>
									<el-col :span="11">
										<el-form-item label="甲方指定负责人：">
											<TextTooltip :content="item.principalAName"
														 :refName="'busProjectContractParties.' + index + '.principalAName'">
											</TextTooltip>
										</el-form-item>
									</el-col>
									<el-col :span="11"
											:offset="1">
										<el-form-item label="甲方签约人联系方式：">
											<span>{{ item.handlerPhone }}</span>
										</el-form-item>
									</el-col>
								</div>
								<div v-else
									 :class="{ borderTop: index == 1 }">
									<el-col :span="24"
											class="mt15"
											v-if="index == 1">
										<el-form-item label="是否联合体：">
											<span>{{ contractForm.comboFlag == 1 ? '是' : '否' }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="11">
										<el-form-item label="签约单位（乙方）：">
											<TextTooltip :content="item.sname"
														 :refName="'busProjectContractParties.' + index + '.sname'">
											</TextTooltip>
										</el-form-item>
									</el-col>
									<el-col :span="11"
											:offset="1">
										<el-form-item label="经办人：">
											<TextTooltip :content="item.handlerName"
														 :refName="'busProjectContractParties.' + index + '.handlerName'">
											</TextTooltip>
										</el-form-item>
									</el-col>
									<el-col :span="11">
										<el-form-item label="经办人联系方式：">
											<span>{{ item.handlerPhone }}</span>
										</el-form-item>
									</el-col>
								</div>
							</el-row>
						</template>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="#3 正文信息"
								  name="3">
					<vxe-table align="center"
							   border
							   :data="uploadData"
							   highlight-current-row
							   highlight-hover-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-table-column title="合同类型"
										  field="type"></vxe-table-column>
						<vxe-table-column title="附件">
							<template #default="{ row }">
								<span class="vxe-table--cell blue-text"
									  v-if="fileLength > 0"
									  @click="doClick('view')">
									查看（共{{ fileLength }} 个文件）
								</span>
								<span v-else>-</span>
							</template>
						</vxe-table-column>
					</vxe-table>
				</el-collapse-item>
				<el-collapse-item title="#4 主要条款信息"
								  name="4">
					<el-form ref="messageInfo"
							 :model="contractForm"
							 label-width="170px">
						<el-row>
							<el-col :span="11">
								<el-form-item label="质量要求：">
									<div class="text-wrap">{{ contractForm.qualityRequire || '无' }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="11"
									:offset="1">
								<el-form-item label="合同违约条款：">
									<div class="text-wrap">{{ contractForm.clause || '无' }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item label="项目进度要求：">
									<div class="text-wrap">{{ contractForm.progressRequire || '无' }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="11"
									:offset="1">
								<el-form-item label="合同付款方式：">
									<div class="text-wrap">{{ contractForm.payMethod || '无' }}</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-collapse-item>
			</el-collapse>
		</div>

		<!-- 上传弹窗 -->
		<el-dialog :title="dialog.title"
				   :visible.sync="dialog.show"
				   width="1200px"
				   append-to-body
				   :close-on-click-modal="false"
				   center>
			<myUpload list-type="table"
					  ref="test"
					  v-if="dialog.show"
					  tableName="bus_project_contract_base"
					  :aid="this.contractForm.id"
					  :isDisabled="true"
					  mode="view"
					  :uploadType="2"></myUpload>
		</el-dialog>
	</div>
</template>
<script>
import * as API from '@/api/approval/approval'
import TextTooltip from '@/views/Common/TextTooltip'
import { mapState } from 'vuex'
import { getFiles } from 'api/upload/upload'
export default {
	name: 'AddContract',
	props: {
		contractObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
		projectName: {
			type: String,
			default: '',
		},
        // 项目id
		projectId: {
			type: String,
			default: '',
		},
	},
	components: {
		TextTooltip,
	},
	data() {
		return {
			activeName: '1',
			activeNames: ['1', '2', '3', '4'],
			contractForm: {
				sname: '', //合同名称
				contractNo: '', //合同编号
				amount: '', //合同金额
				type: '', //签约合同类型
				remark: '', //备注
				qualityRequire: '', //质量要求
				clause: '', //合同违约条款
				taskIds: [], //关联任务
				progressRequire: '', //进度要求
				payMethod: '', //合同付款方式
				status: '1011001', //合同状态
				startDate: '', //合同开始日期
				endDate: '', //合同结束日期
				comboFlag: 0, //是否联合体
				isEstimate: '', //是否估值 * 0：否  * 1：是
				chargeBase: '', //计费基数
				rate: '', //费率
				discount: '', //优惠折扣
				// 签约双方信息
				busProjectContractParties: [],
			},
			itemName: '', // 所属项目
			copyObj: {}, //用来操作签约双方信息
			uploadData: [{ id: '10001' }],
			fileLength: 0, //文件长度
			contractId: '', //合同id
			contractTypeList: [], // 合同类型
            templateId: '',
			dialog: {
				title: '',
				show: false,
				type: '',
			},
		}
	},
	created() {
		// 获取合同类型
		this.getContractType()
		// 获取合同信息
		this.getContractData()
	},
	mounted() {
		if (this.routeType == 'add') {
			this.copyObj = this.$utils.clone(this.contractForm, true)
		}
	},
	methods: {
		// 获取合同信息
		getContractData() {
			API.getContractDetails({
				id: this.contractObj.id,
			}).then((res) => {
				let data = this.$utils.clone(res.data, true)
				this.contractForm = data.busProjectContractBase
				this.contractId = data.id
				// 回显正文信息合同类型
				this.$set(
					this.uploadData[0],
					'type',
					data.busProjectContractBase.contractName
				)
				// 处理估值
				data.busProjectContractBase.isEstimate
					? (this.contractForm.isEstimate = true)
					: (this.contractForm.isEstimate = false)
				if (!!this.contractForm.taskIds) {
					this.contractForm.taskIds =
						this.contractForm.taskIds.split(',')
				}
				this.contractForm.busProjectContractParties = []
				data.partyA.forEach((item) => {
					this.contractForm.busProjectContractParties.push(item)
				})
				data.partyB.forEach((item1) => {
					this.contractForm.busProjectContractParties.push(item1)
				})
				this.copyObj = this.$utils.clone(this.contractForm, true)
				if (this.routeType != 'add') {
					this.getFiles(data.id)
				}

                if (this.routeType === 'check' || this.routeType === 'view') {
                    let list = this.$utils.filterTree(
						this.contractTypeList,
						(x) => x.id == this.contractForm.contractId,
						{ children: 'child' }
					)

					setTimeout(() => {
						this.templateId = list[0].templateId
					}, 300)
                }
			})
		},

		// 上传弹窗
		doClick(type) {
			this.dialog.title = '查看资料'
			this.dialog.type = type
			this.dialog.show = true
		},

		// 数据回显
		getFiles(id) {
			this.$nextTick(() => {
				getFiles({
					aid: id,
					tableName: 'bus_project_contract_base',
					assortment: '',
					source: '1',
				})
					.then((res) => {
						this.fileList = res.data
						this.fileLength = this.fileList.length
					})
					.catch((err) => {
						this.fileList = []
					})
			})
		},

		// 获取合同类型
		getContractType() {
			API.getBusProjectContract({
				projectId: this.contractObj.projectId,
                dataFormatSign: 1,
			}).then((res) => {
				this.contractTypeList = res.data
			})
		},

        // 处理附件
		dealFile(data) {
			let msg = ''
			switch (data) {
				case '1437668987788988416':
					msg = '国家计委1283号文《工程咨询收费标准》'
					this.jumpUrl =
						'https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gczxsfbz'
					break
				case '1437668987805765632':
					msg = '计价格[2002]10号，《工程勘察设计收费管理规定》'
					this.jumpUrl =
						'https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gcsjsfbz'
					break
				case '1437668987818348544':
					msg = '皖价服[2007]86号《工程造价咨询服务收费标准》'
					this.jumpUrl =
						'https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=gczjfwsfbz'
					break
				case '1437668987839320064':
					msg =
						'发改价格[2007]670号，《建设工程监理与相关服务收费管理规定》'
					this.jumpUrl =
						'https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=sgjlsfbz'
					break
				case '1437668987851902976':
					msg = '计价格[2002]1980号，《招标代理服务收费管理暂行办法》'
					this.jumpUrl =
						'https://www.52ngs.com/calculator-cloud/caculator/browserOline.do?fileid=zbdlsfbz'
					break
				default:
					msg = ''
					this.jumpUrl = ''
			}
			return msg
		},

		// 跳转
		jumpHref() {
			window.open(this.jumpUrl, '_blank')
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		// 获取路由中的 type
		routeType() {
			return this.$route.query.type
		},
	},
}
</script>
<style lang='less' scoped>
.add-layout-contract {
	height: 100%;
	padding-top: 15px;
	.el-form-item {
		margin-bottom: 15px !important;
		/deep/ .el-input--suffix .el-input__inner {
			padding-right: 75px !important;
		}
		.no-padding {
			/deep/ .el-input__inner {
				padding-right: 15px !important;
			}
		}
	}
	.primary-content {
		padding: 10px 20px 0 20px;
		overflow-y: auto !important;
	}
	.el-collapse {
		.el-collapse-item {
			margin-bottom: 15px;
		}
		/deep/ .el-collapse-item__header {
			padding-left: 15px;
			font-size: 16px;
			background-color: #eff6fe;
		}
		/deep/ .el-collapse-item__content {
			padding: 15px;
		}
		/deep/.el-collapse-item__wrap {
			border-bottom: none !important;
		}
	}
	.borderTop {
		border-top: 2px dotted #eee;
	}
	.blue-text {
		color: #60adf9;
		cursor: pointer;
		text-decoration: underline;
	}
	.noStar {
		/deep/ .el-form-item__label::before {
			content: '';
			color: transparent;
		}
	}
	.text-wrap {
		word-wrap: break-word;
	}
	.red {
		color: red;
		margin-bottom: 15px;
	}
}
</style>

